import mapValues from 'lodash/mapValues';
import round from 'lodash/round';
import sumBy from 'lodash/sumBy';
import moment from 'moment';

import { budgets as BUDGETS } from '../campaign-editor/constants';
import { getBusinessBudgets } from '../campaigns/utils/get-budgets';

function opportunitiesCreatedThisYear(opportunities) {
  return opportunities.filter(
    o =>
      moment(o.created) > moment().startOf('year') &&
      moment(o.created) < moment().endOf('year'),
  );
}

function campaignsEndingThisYear(campaigns) {
  return campaigns.filter(c => {
    const endDate = c.endDateIs ? 'endDateIs' : 'endDatePlanned';
    return (
      moment(c[endDate]) > moment().startOf('year') &&
      moment(c[endDate]) < moment().endOf('year')
    );
  });
}

function allCampaignsAllBudgets(campaigns) {
  return sumBy(campaigns, 'spendableBudget');
}

function budgetByCategories(campaigns, spendableBudget) {
  return BUDGETS.map(({ business, name }) => {
    const value = sumBy(campaigns, `budgets["${business}"]`);
    const percentage = round((value / spendableBudget || 0) * 100, 2);
    return { title: name, value, percentage };
  });
}

function pieChartData(categorizedBudgets) {
  return categorizedBudgets.map(item => [item.title, item.percentage]);
}

function endedCampaigns(campaigns) {
  return campaigns.filter(c => c.status === 'Ended').length;
}

function runningCampaigns(campaigns) {
  return campaigns.filter(c => c.status === 'Running').length;
}

function opportunityRevenue(opportunities) {
  return sumBy(
    opportunitiesCreatedThisYear(opportunities),
    o => o.expectedRevenue * (o.probability / 100),
  );
}

function transformMultiBrandBudgets(campaigns) {
  return campaigns.map(campaign => {
    if (!campaign.brands || campaign.brands.length < 2) {
      return campaign;
    }

    return {
      ...campaign,
      spendableBudget: campaign.spendableBudget / campaign.brands.length,
      budgets: mapValues(
        campaign.budgets,
        budget => budget / campaign.brands.length,
      ),
    };
  });
}

function withBudgets(campaign) {
  return { ...campaign, budgets: getBusinessBudgets(campaign) };
}

export default function calculateCampaignStatistics(
  campaigns,
  opportunities,
  normalizeMultiBrandBudgets,
) {
  const currentCampaigns = campaignsEndingThisYear(campaigns).map(withBudgets);
  const normalizedBudgetCampaigns = normalizeMultiBrandBudgets
    ? transformMultiBrandBudgets(currentCampaigns)
    : currentCampaigns;

  const spendableBudget = allCampaignsAllBudgets(normalizedBudgetCampaigns);
  const categorizedBudgets = budgetByCategories(
    normalizedBudgetCampaigns,
    spendableBudget,
  );

  return {
    opportunityRevenue: opportunityRevenue(opportunities),

    allCampaignsBudget: spendableBudget,
    budgetByCategories: categorizedBudgets,

    pieChartData: pieChartData(categorizedBudgets),
    runningCampaigns: runningCampaigns(campaigns),
    endedCampaigns: endedCampaigns(currentCampaigns),
  };
}
